export const BUSINESS_PROFILE_REDUCER = 'businessProfile'
export const CREATE_PROFILE_REDUCER = 'createProfile'
export const GLOBAL_REDUCER = 'global'
